@if (showFilters$ | async; as enabledFilters) { @if (currentPage.value !== "contingent" || !(viewOnlyOwnContingent |
async)) { @if (enabledFilters.enabled) {
<mat-toolbar class="mat-toolbar-secondary mat-toolbar-mw scroll-auto">
	<div class="flex flex-auto flex-row items-center justify-start gap-4 pb-2 pt-3">
		<div
			class="mat-hint mat-typography font-bold"
			fxHide.lt-sm
		>
			{{ "utils.filter" | translate }}:
		</div>
		<div class="flex flex-auto flex-row items-center justify-start gap-2">
			<div class="flex flex-auto items-center space-x-2">
				@if (enabledFilters.team) {
				<button
					(click)="employeeFilterPopover.toggle()"
					[active]="(teamFilter.value$ | async)?.length > 0"
					[count]="(teamFilter.value$ | async)?.length ?? 0"
					[satPopoverAnchor]="employeeFilterPopover"
					icon="supervisor_account"
					labelKey="reports.filter-bar.users"
					tgFilterTrigger
				></button>
				} @if ( enabledFilters.group && ((userIsAdmin.value$ | async) || (userIsWorkspaceManager | async)) ) {
				<button
					(click)="groupFilterPopover.toggle()"
					[active]="(groupFilter.value$ | async)?.length > 0"
					[count]="(groupFilter.value$ | async)?.length ?? 0"
					[satPopoverAnchor]="groupFilterPopover"
					icon="groups"
					labelKey="reports.filter-bar.groups"
					tgFilterTrigger
				></button>
				} @if ((comegoEnabled$ | async) && enabledFilters.comegoType) {
				<button
					(click)="comegoTypeFilterPopover.toggle()"
					[active]="(comegoTypeFilter.value$ | async)?.length > 0"
					[count]="(comegoTypeFilter.value$ | async)?.length ?? 0"
					[satPopoverAnchor]="comegoTypeFilterPopover"
					icon="work_history"
					labelKey="reports.filter-bar.comegoType"
					tgFilterTrigger
				></button>
				} @if (enabledFilters.project) {
				<button
					(click)="projectFilterPopover.toggle()"
					[active]="(projectFilter.value$ | async)?.length > 0"
					[count]="(projectFilter.value$ | async)?.length ?? 0"
					[satPopoverAnchor]="projectFilterPopover"
					icon="folder"
					labelKey="reports.filter-bar.projects"
					tgFilterTrigger
				></button>
				} @if (enabledFilters.client) {
				<button
					(click)="clientFilterPopover.toggle()"
					[active]="(clientFilter.value$ | async)?.length > 0"
					[count]="(clientFilter.value$ | async)?.length ?? 0"
					[satPopoverAnchor]="clientFilterPopover"
					icon="person"
					labelKey="reports.filter-bar.clients"
					tgFilterTrigger
				></button>
				} @if (enabledFilters.task) {
				<button
					(click)="taskFilterPopover.toggle()"
					[active]="(taskFilter.value$ | async)?.length > 0"
					[count]="(taskFilter.value$ | async)?.length ?? 0"
					[satPopoverAnchor]="taskFilterPopover"
					icon="check_circle"
					labelKey="reports.filter-bar.tasks"
					tgFilterTrigger
				></button>
				} @if (enabledFilters.tag) {
				<button
					(click)="tagFilterPopover.toggle()"
					[active]="(tagFilter.value$ | async)?.length > 0"
					[count]="(tagFilter.value$ | async)?.length ?? 0"
					[satPopoverAnchor]="tagFilterPopover"
					icon="label"
					labelKey="reports.filter-bar.tags"
					tgFilterTrigger
				></button>
				} @if (enabledFilters.billable) {
				<button
					(click)="btm?.toggle()"
					[class.active]="billableFilter$active | async"
					[matMenuTriggerFor]="billToggleMenu"
					#btm="matMenuTrigger"
					class="mat-button-alt"
				>
					<div class="flex flex-row items-center justify-start gap-1">
						<mat-icon inline>attach_money</mat-icon>
						<span translate>filter-toolbar.billable-filter</span>
					</div>
				</button>
				} @if (enabledFilters.audit) {
				<button
					(click)="auditFilterPopover.toggle()"
					[active]="(auditFilter$active | async) === true"
					[badgeWhenActive]="true"
					[satPopoverAnchor]="auditFilterPopover"
					icon="fact_check"
					labelKey="reports.filter-bar.audit"
					tgFilterTrigger
				></button>
				} @if ((isDefaultFilter$ | async) === false) {
				<button
					(click)="resetFilters.emit()"
					[matTooltip]="'utils.all-clear' | translate"
					class="!leading-normal"
					mat-icon-button
				>
					<mat-icon>clear</mat-icon>
				</button>
				}
			</div>
			@if (showManageDashboards$ | async) {
			<button
				(click)="manageDashboards.emit()"
				class="mat-button-alt"
			>
				<div class="flex flex-row items-center justify-start gap-1">
					<mat-icon inline>bookmark</mat-icon>
					<span>{{ "dashboard.manage" | translate }}</span>
				</div>
			</button>
			} @if (enabledFilters.amount) {
			<mat-divider
				class="h-8"
				vertical
			></mat-divider>
			@if (canViewAmount | async) {
			<div class="flex flex-row items-center space-x-1">
				<div
					(click)="amountToggle.value = !amountToggle.value"
					[matTooltip]="'time.show-amount' | translate"
					[ngClass]="{ 'opacity-70': !amountToggle.value }"
					class="h-9 cursor-pointer select-none px-2 leading-9"
				>
					<mat-icon inline>{{ amountToggle.value ? "attach_money" : "money_off" }}</mat-icon>
				</div>
			</div>
			} } @if (currentPage.value == "contingent") {
			<mat-divider
				class="h-8"
				vertical
			></mat-divider>
			<div class="flex flex-row items-center space-x-1">
				<div
					(click)="noStartDateToggle.update(!noStartDateToggle.value)"
					[matTooltip]="'workspace.timecontingent.show-without-startdate' | translate"
					[ngClass]="{ 'opacity-70': !noStartDateToggle.value }"
					class="h-10 cursor-pointer select-none px-2 leading-10"
				>
					<mat-icon inline>{{ noStartDateToggle.value ? "event_available" : "event_busy" }}</mat-icon>
				</div>
			</div>
			}
		</div>
	</div>
</mat-toolbar>
} } }

<mat-menu #billToggleMenu="matMenu">
	<div class="m-2">
		<mat-radio-group [(ngModel)]="billableFilter.value">
			<div class="flex flex-col gap-1.5">
				<mat-radio-button [value]="0">{{ "Dashboard_Both" | translate }}</mat-radio-button>
				<mat-radio-button [value]="2">{{ "dashboard.billed" | translate }}</mat-radio-button>
				<mat-radio-button [value]="1">{{ "dashboard.nonBilled" | translate }}</mat-radio-button>
			</div>
		</mat-radio-group>
	</div>
</mat-menu>

<tg-project-filter-popover
	(itemsClose)="projectFilter.value = $event"
	(showCompletedChange)="showCompletedChange.emit($event)"
	[selectedItems]="projectFilter.value"
	[showCompleted]="(showCompletedProjects$ | async) ?? false"
	#projectFilterPopover
></tg-project-filter-popover>
<tg-client-filter-popover
	(itemsClose)="clientFilter.value = $event"
	[selectedItems]="clientFilter.value"
	#clientFilterPopover
></tg-client-filter-popover>
<tg-employee-filter-popover
	(itemsClose)="teamFilter.value = $event"
	(toggleRemoved)="employeeFilterIncludesRemoved.value = $event"
	[selectedItems]="teamFilter.value"
	#employeeFilterPopover
></tg-employee-filter-popover>
<tg-task-filter-popover
	(itemsClose)="taskFilter.value = $event"
	[projects]="projectFilter.value"
	[selectedItems]="taskFilter.value"
	#taskFilterPopover
></tg-task-filter-popover>
<tg-tag-filter-popover
	(itemsClose)="tagFilter.value = $event"
	[selectedItems]="tagFilter.value"
	#tagFilterPopover
></tg-tag-filter-popover>
<tg-groups-filter-popover
	(itemsClose)="groupFilter.value = $event"
	[excludeSystemGroups]="true"
	[selectedItems]="groupFilter.value"
	#groupFilterPopover
></tg-groups-filter-popover>
<tg-audit-filter-popover
	[(ngModel)]="auditFilter.value"
	[comegoTimes]="(currentPage.value$ | async) === 'workinghours'"
	#auditFilterPopover
></tg-audit-filter-popover>
<tg-comego-type-filter-popover
	(itemsClose)="comegoTypeFilter.value = $event"
	[selectedItems]="comegoTypeFilter.value"
	#comegoTypeFilterPopover
></tg-comego-type-filter-popover>
